import { render, staticRenderFns } from "./CountdownWidget.vue?vue&type=template&id=90e038cc&scoped=true"
import script from "./CountdownWidget.vue?vue&type=script&lang=js"
export * from "./CountdownWidget.vue?vue&type=script&lang=js"
import style0 from "./CountdownWidget.vue?vue&type=style&index=0&id=90e038cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e038cc",
  null
  
)

export default component.exports